var map = {
	"./7.png": "4A5Y",
	"./7en.png": "/DuS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VOem";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo ^\.\/7.*\.png$
// module id = VOem
// module chunks = 0